import React, { useState } from "react";
import css from "../Data.module.css";
import { useSession } from "../../../../hooks/session";
import { useImportSession } from "../../../../hooks/import";
import { saveAs } from "file-saver";

const SessionInfo = ({ sessionId, layoutFns }) => {
  const { data, isLoading } = useSession(sessionId);

  const { importSession } = useImportSession();

  const [fileContent, setFileContent] = useState(""),
    [sendable, setSendable] = useState(false),
    [message, setMessage] = useState(isLoading ? "" : data.integration_message);

  const uploadFile = (e) => {
    const uploadedFile = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      try {
        setFileContent(JSON.parse(fileReader.result));
        setSendable(true);
        setMessage("JSON successfully uploaded.");
      } catch (e) {
        setSendable(false);
        setFileContent("");
        setMessage("Error on JSON file.");
      }
    };

    if (uploadedFile !== undefined) fileReader.readAsText(uploadedFile);
  };

  return (
    <div className={css.session}>
      <h2 className={css.sessionTitle}>Session Info</h2>
      <div className={css.sessionContent}>
        <div className={css.sessionInfoDescription}>
          <p style={{ color: "grey", lineHeight: "1.3" }}>
            In this section the user can save the actual status of the network,
            (e.g. network types, position, colors, etc...) in order to import it
            later.
            <br />
            Do not modify the session file.
          </p>
        </div>
        <button
          className={css.exportSession}
          onClick={() => exportSession(data, layoutFns.getCyElements())}
        >
          Export Session
        </button>
        <form
          className={css.formImportSession}
          onSubmit={(event) => {
            event.preventDefault();
            importSession(fileContent);
          }}
        >
          <input type="file" name="filename" onChange={uploadFile} />
          <button
            type="submit"
            className={css.importPosition}
            disabled={!sendable}
          >
            Import Session
          </button>
        </form>
        <textarea className={css.textArea} value={message} readOnly={true} />
      </div>
    </div>
  );
};

export default SessionInfo;

const exportSession = (data, cyElements) => {
  let position = {};
  let color_payload = {};
  let colors = {};

  for (let i = 0; i < cyElements.length; i++) {
    if (cyElements[i].group === "nodes") {
      position[cyElements[i].data.id] = {
        position: cyElements[i].position,
        label: cyElements[i].data.label,
      };

      if (data.userColorImported.flag) {
        let float_value;
        if ("User Numeric Value" in cyElements[i].data) {
          float_value = parseFloat(cyElements[i].data["User Numeric Value"]);
        } else {
          float_value = false;
        }

        colors[cyElements[i].data.label] = [cyElements[i].data.color, float_value];
      }
    }
  }

  if (data.userColorImported.flag) {
    color_payload["case_sensitive"] = data.userColorImported.case_sensitive;
    color_payload["color_list"] = colors; 
    color_payload["header_label"] = data.userColorImported.header_label;
  }

  const session = {
    pathway_internal_id: data.pathwayInternalId,
    protein_type: data.protein_type,
    network_type: data.network_type,
    user_position: position,
    user_colors: color_payload,
  };

  saveSessionJSON(session);
};

function saveSessionJSON(json) {
  const jsonBlob = new Blob([JSON.stringify(json)], {
    type: "application/javascript;charset=utf-8",
  });
  saveAs(jsonBlob, "session.json");
}
